import { SortingDirection } from '@common/react/components/Core/ItemsProvider/ItemsProvider';
import {
	ItemsProviderWithStoreProps,
} from '@common/react/components/Core/ItemsProviderWithStore/ItemsProviderWithStore';

import { Location } from '@app/objects/Location';

type pickProperties = 'defaultSort' | 'filterHandler' | 'sortHandler' | 'storeName' | 'loadRequest' | 'pagination'
	| 'filters';

export const defaultOptions: Pick<ItemsProviderWithStoreProps<Location>, pickProperties> = {
	defaultSort: ['id', SortingDirection.Ascending],
	filterHandler: () => true,
	sortHandler: (a, b) => (a.id - b.id),
	storeName: 'locations',
	loadRequest: 'locationActiveTimeViewList',
	pagination: { current: 1, pageSize: 100 },
	filters: {
		column: [{ caption: 'id', direction: SortingDirection.Ascending }],
		count: 100,
	},
};
